import type {
  DocNetDashboardStatsResponse,
  DocNetDashboardTrendsResponse,
  DocNetDashboardWidgetsResponse,
} from 'src/@types/docnet';
import DocNetBaseService from 'src/services/docnet/DocNetBaseService';
import { api } from 'src/pages/APIs';

export default class DocNetDashboardService extends DocNetBaseService {
  public async getStats(): Promise<DocNetDashboardStatsResponse> {
    const headers = await this.getHeaders();
    const response = await super.get(api.docnet_dashboard_stats, { headers });
    return response as DocNetDashboardStatsResponse;
  }

  public async getTrends(
    lookbackDays = 14,
  ): Promise<DocNetDashboardTrendsResponse> {
    const headers = await this.getHeaders();
    const url = `${api.docnet_dashboard_trends}?days=${lookbackDays}`;
    const response = await super.get(url, { headers });
    return response as DocNetDashboardTrendsResponse;
  }

  public async getWidgets(
    widgetKeys: string[],
  ): Promise<DocNetDashboardWidgetsResponse> {
    if (widgetKeys.length === 0) return {};
    const headers = await this.getHeaders();
    const params = widgetKeys.map((k) => `widgets=${encodeURIComponent(k)}`).join('&');
    const url = `${api.docnet_dashboard_widgets}?${params}`;
    const response = await super.get(url, { headers });
    return response as DocNetDashboardWidgetsResponse;
  }
}
